export default "__VITE_ASSET__da412314__"